export default __webpack_public_path__ + "static/media/RectangleRight.ab74affa.png";